var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "goods_nav_config",
      attrs: { disabled: _vm.disabled, model: _vm.value.config },
    },
    [
      _c("div", [_vm._v("选择展示样式")]),
      _c(
        "el-form-item",
        {
          staticClass: "show_type",
          attrs: {
            prop: "show_type",
            rules: [
              {
                required: true,
                message: "请先选择一种样式",
                trigger: "change",
              },
            ],
          },
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            _vm._l(_vm.typeList, function (item) {
              return _c(
                "div",
                {
                  key: item.id,
                  class: [
                    "type-box",
                    item.id == _vm.value.config.show_type && "checked",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.changeType(item)
                    },
                  },
                },
                [
                  _c("el-image", {
                    staticClass: "img",
                    attrs: { fit: "contain", src: item.imageurl },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "menu" },
        [
          _c("div", { staticClass: "label" }, [_vm._v("选择菜单")]),
          _c(
            "el-form-item",
            {
              attrs: {
                rules: [{ required: true, message: "菜单不可为空" }],
                prop: "category_id",
              },
            },
            [
              _c("el-cascader", {
                staticStyle: { width: "100%" },
                attrs: {
                  options: _vm.menuListFilter,
                  props: {
                    label: "show_name",
                    value: "id",
                    children: "childrens",
                    checkStrictly: true,
                    emitPath: false,
                  },
                  disabled: _vm.disabled || Boolean(_vm.parentKey),
                  "collapse-tags": "",
                  filterable: "",
                  placeholder: "选择实体产品菜单",
                },
                on: { change: _vm.changeCategory },
                model: {
                  value: _vm.value.config.category_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "category_id", $$v)
                  },
                  expression: "value.config.category_id",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "sort" },
        [
          _c("div", { staticClass: "label" }, [_vm._v("商品排序方式")]),
          _c(
            "el-form-item",
            {
              attrs: {
                rules: [{ required: true, message: "商品排序方式不可为空" }],
                prop: "sort",
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.value.config.sort,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "sort", $$v)
                    },
                    expression: "value.config.sort",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "radio" },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v(" 按商品列表默认排序（即按商品ID大到小） "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "radio" },
                    [
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v(" 按商品更新时间倒序展示（更新时间晚到早） "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "radio" },
                    [
                      _c("el-radio", { attrs: { label: "3" } }, [
                        _vm._v(
                          " 按商品排序值正序展示（即按商品排序值小到大） "
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      [1, 3].includes(_vm.value.config.show_type)
        ? _c(
            "el-form-item",
            { attrs: { prop: "is_open_ad", label: "插入广告" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.value.config.is_open_ad,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "is_open_ad", $$v)
                    },
                    expression: "value.config.is_open_ad",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("开启")]),
                  _c("el-radio", { attrs: { label: "0" } }, [_vm._v("关闭")]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.value.config.is_open_ad === "1"
        ? _vm._l(_vm.value.config.ads, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "upload-item" },
              [
                _c(
                  "div",
                  { staticClass: "upload" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "ads." + index + ".imageurl",
                          rules: [{ required: true, message: "图片不可为空" }],
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "upload-item-wrap" },
                          [
                            _c("upload-file", {
                              ref: "uploadBanner",
                              refInFor: true,
                              attrs: {
                                "link-url": _vm.linkUrl,
                                tempurl: item.imageurl,
                                uploadInfo: _vm.uploadInfo,
                              },
                              on: {
                                emitUploadFile: function (res) {
                                  return _vm.emitUploadFile(res, item)
                                },
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "btns" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.onUpload(index)
                                      },
                                    },
                                  },
                                  [_vm._v(" 上传图片 ")]
                                ),
                                _vm.pictureList.length > 0
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectPicture(index)
                                          },
                                        },
                                      },
                                      [_vm._v(" 选择图片 ")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "tips" }, [
                      _vm._v(
                        " 建议尺寸为宽度" +
                          _vm._s(
                            _vm.value.config.show_type === 1 ? "330" : "220"
                          ) +
                          "px，高度等比例展示，支持png、gif格式图 "
                      ),
                    ]),
                  ],
                  1
                ),
                _c("config-menu", {
                  key: item.uid,
                  attrs: {
                    propName: "ads",
                    value: item,
                    type: _vm.value.key,
                    index: index,
                    info: _vm.info,
                    menuList: _vm.menuList,
                    childrenMenuList: _vm.childrenMenuList,
                    customerModuleList: _vm.customerModuleList,
                    eBookCategoryList: _vm.eBookCategoryList,
                    aBookCategoryList: _vm.aBookCategoryList,
                    customerPackageList: _vm.customerPackageList,
                    systemMenus: _vm.systemMenus,
                  },
                }),
              ],
              1
            )
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "sort line_number" },
        [
          _c(
            "div",
            { staticClass: "label" },
            [
              _vm._v(" 商品列表显示模式 "),
              _c(
                "el-tooltip",
                { attrs: { effect: "dark", placement: "top" } },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(
                      " 选择「显示固定行数的商品」，表示共显示所设行数的商品，可控制底下是否显示查看更多；"
                    ),
                    _c("br"),
                    _vm._v(
                      "选择「上滑无限加载商品」，表示每次上滑加载所设行数的商品。 "
                    ),
                  ]),
                  _c("span", { staticClass: "tips" }, [
                    _vm._v(" 说明 "),
                    _c("i", { staticClass: "el-icon el-icon-warning-outline" }),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                rules: [
                  {
                    required: true,
                    validator: function (rule, value, callback) {
                      return _vm.checkNumber(rule, value, callback)
                    },
                    trigger: "change",
                  },
                ],
                prop: "line_number",
              },
            },
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: "请输入商品展示行数" },
                  model: {
                    value: _vm.value.config.line_number,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "line_number", $$v)
                    },
                    expression: "value.config.line_number",
                  },
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("显示")]),
                  _c("template", { slot: "append" }, [_vm._v("行")]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                rules: [
                  {
                    required: true,
                    trigger: "change",
                  },
                ],
                prop: "list_show_type",
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.value.config.list_show_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "list_show_type", $$v)
                    },
                    expression: "value.config.list_show_type",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "radio" },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(" 显示固定行数的商品 "),
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            rules: [
                              {
                                required: true,
                                trigger: "change",
                              },
                            ],
                            prop: "list_show_more",
                          },
                        },
                        [
                          _vm._v(" 底部显示「查看更多」按钮 "),
                          _c("el-switch", {
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            model: {
                              value: _vm.value.config.list_show_more,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.value.config,
                                  "list_show_more",
                                  $$v
                                )
                              },
                              expression: "value.config.list_show_more",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "radio" },
                    [
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v(" 上滑无限加载商品 "),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.parentKey
        ? _c(
            "div",
            [
              _c("div", { staticClass: "label" }, [
                _vm._v(" 是否开启副标题 "),
                _c("span", { staticClass: "tips" }, [
                  _vm._v(
                    " （开启副标题功能，每个分类都要填，保证前台显示整齐好看。） "
                  ),
                ]),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    rules: [
                      {
                        required: true,
                        trigger: "change",
                      },
                    ],
                    prop: "is_open_sub_name",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.value.config.is_open_sub_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.value.config, "is_open_sub_name", $$v)
                        },
                        expression: "value.config.is_open_sub_name",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("关闭"),
                      ]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("开启"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.value.config.show_type == 4
        ? [
            _c("div", { staticClass: "label tag_label" }, [
              _vm._v("价签标签配置"),
            ]),
            _c("div", { staticClass: "tag-label-tips" }, [
              _vm._v(
                " 划线价是否展示取菜单配置；以下配置用于控制C端促销标签及进入商品按钮文案。 "
              ),
            ]),
            _c("div", { staticClass: "tag-config-box" }, [
              _c("div", { staticClass: "tag-row" }, [
                _c(
                  "div",
                  { staticClass: "tag-row-content discount-line" },
                  [
                    _c("span", { staticClass: "tag-text" }, [_vm._v("折扣 ≥")]),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "tag-discount",
                        attrs: {
                          prop: "tag_discount",
                          rules: [
                            {
                              required: true,
                              validator: _vm.checkTagDiscount,
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "9.5" },
                          on: { input: _vm.onTagDiscountInput },
                          model: {
                            value: _vm.value.config.tag_discount,
                            callback: function ($$v) {
                              _vm.$set(_vm.value.config, "tag_discount", $$v)
                            },
                            expression: "value.config.tag_discount",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("span", { staticClass: "tag-text" }, [
                      _vm._v("折且 < 10 折，展示"),
                    ]),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "tag-discount-text",
                        attrs: {
                          prop: "tag_discount_text",
                          rules: [
                            {
                              required: true,
                              message: "折扣文案不可为空",
                              trigger: "blur",
                            },
                            {
                              max: 2,
                              message: "折扣文案最多 2 个字",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "立省",
                            maxlength: "2",
                            "show-word-limit": "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.value.config.tag_discount_text,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.value.config,
                                "tag_discount_text",
                                $$v
                              )
                            },
                            expression: "value.config.tag_discount_text",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "tag-row-tips",
                    staticStyle: { "margin-top": "18px" },
                  },
                  [_vm._v(" 折扣限制：0 至 9.9 折，支持 1 位小数。 ")]
                ),
              ]),
              _c("div", { staticClass: "tag-row" }, [
                _c("div", { staticClass: "tag-row-label" }, [
                  _vm._v(" 无折扣、折扣 ≥ 10 折或划线价关闭文案 "),
                ]),
                _c(
                  "div",
                  { staticClass: "tag-row-content" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "tag-no-discount-text",
                        attrs: {
                          prop: "tag_no_discount_text",
                          rules: [
                            {
                              required: true,
                              message: "无折扣文案不可为空",
                              trigger: "blur",
                            },
                            {
                              max: 4,
                              message: "无折扣文案最多 4 个字",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "超值好物",
                            maxlength: "4",
                            "show-word-limit": "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.value.config.tag_no_discount_text,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.value.config,
                                "tag_no_discount_text",
                                $$v
                              )
                            },
                            expression: "value.config.tag_no_discount_text",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "tag-row" }, [
                _c("div", { staticClass: "tag-row-label" }, [
                  _vm._v("进入商品按钮文案"),
                ]),
                _c(
                  "div",
                  { staticClass: "tag-row-content" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "tag-btn-text",
                        attrs: {
                          prop: "tag_btn_text",
                          rules: [
                            {
                              required: true,
                              message: "按钮文案不可为空",
                              trigger: "blur",
                            },
                            {
                              max: 1,
                              message: "按钮文案最多 1 个字",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "抢",
                            maxlength: "1",
                            "show-word-limit": "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.value.config.tag_btn_text,
                            callback: function ($$v) {
                              _vm.$set(_vm.value.config, "tag_btn_text", $$v)
                            },
                            expression: "value.config.tag_btn_text",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        : _vm._e(),
      !_vm.parentKey
        ? [
            _c("div", { staticClass: "label" }, [
              _vm._v(" 设置分类及排序 "),
              _c("span", { staticClass: "tips" }, [
                _vm._v("（拖动分类可调整排序）"),
              ]),
            ]),
            _c(
              "draggable",
              {
                attrs: { animation: "500", "force-fallback": true },
                model: {
                  value: _vm.value.config.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "value", $$v)
                  },
                  expression: "value.config.value",
                },
              },
              _vm._l(_vm.value.config.value, function (item, index) {
                return _c(
                  "div",
                  { key: item.id, class: ["box", !item.flag && "disabled"] },
                  [
                    _c(
                      "div",
                      { staticClass: "list" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v(" " + _vm._s(item.primitiveName) + " "),
                        ]),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { margin: "0" },
                            attrs: { prop: "value." + index + ".flag" },
                          },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-value": true,
                                "inactive-value": false,
                              },
                              on: { change: _vm.changeSwitch },
                              model: {
                                value: item.flag,
                                callback: function ($$v) {
                                  _vm.$set(item, "flag", $$v)
                                },
                                expression: "item.flag",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "list" },
                      [
                        _c("div", { staticClass: "label nickName" }, [
                          _vm._v("展示为"),
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "value." + index + ".name",
                              rules: [
                                {
                                  required: true,
                                  validator: function (rule, value, callback) {
                                    return _vm.checkList(
                                      "name",
                                      value,
                                      callback,
                                      item.flag
                                    )
                                  },
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { clearable: "", disabled: !item.flag },
                              model: {
                                value: item.name,
                                callback: function ($$v) {
                                  _vm.$set(item, "name", $$v)
                                },
                                expression: "item.name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.value.config.is_open_sub_name === "1"
                      ? _c(
                          "div",
                          { staticClass: "list" },
                          [
                            _c("div", { staticClass: "label nickName" }, [
                              _vm._v("副标题"),
                            ]),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "value." + index + ".sub_name",
                                  rules: [
                                    {
                                      min: 1,
                                      max: 15,
                                      message: "副标题长度为1-15个字",
                                    },
                                    {
                                      required: true,
                                      validator: function (
                                        rule,
                                        value,
                                        callback
                                      ) {
                                        return _vm.checkList(
                                          "sub_name",
                                          value,
                                          callback,
                                          item.flag
                                        )
                                      },
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    clearable: "",
                                    disabled: !item.flag,
                                    placeholder: "可输入1-15个字",
                                  },
                                  model: {
                                    value: item.sub_name,
                                    callback: function ($$v) {
                                      _vm.$set(item, "sub_name", $$v)
                                    },
                                    expression: "item.sub_name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]
        : _vm._e(),
      !_vm.parentKey
        ? [
            _c(
              "div",
              { staticClass: "label", staticStyle: { "margin-bottom": "0" } },
              [_vm._v("是否显示标题栏")]
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  rules: [
                    {
                      required: true,
                      trigger: "change",
                    },
                  ],
                  prop: "is_show_title",
                },
              },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.value.config.is_show_title,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "is_show_title", $$v)
                      },
                      expression: "value.config.is_show_title",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 0 } }, [_vm._v("不显示")]),
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("显示")]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      !_vm.parentKey
        ? _c(
            "el-form-item",
            {
              staticClass: "margin_top",
              attrs: {
                prop: "margin_top",
                rules: [{ type: "number", message: "间距必须为数字值" }],
              },
            },
            [
              _c("div", [_vm._v("与上方组件的间距")]),
              _c("el-input", {
                attrs: { placeholder: "请输入间距", clearable: "" },
                model: {
                  value: _vm.value.config.margin_top,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
                  },
                  expression: "value.config.margin_top",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.parentKey
        ? _c(
            "el-form-item",
            {
              staticClass: "z_index",
              attrs: {
                prop: "z_index",
                rules: [
                  {
                    required: true,
                    pattern: /^(?:[1-9]|[1-9][0-9])$/,
                    message: "请输入1-99之间的整数！",
                  },
                ],
              },
            },
            [
              _c("div", [_vm._v("层级高度值")]),
              _c("el-input", {
                attrs: { placeholder: "请输入层级高度值", clearable: "" },
                model: {
                  value: _vm.value.config.z_index,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
                  },
                  expression: "value.config.z_index",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }